<template>
  <textarea :id="id" ref="editor" style="cursor:text;" v-model=$data._value :placeholder="placeholder"></textarea>
</template>

<script lang="ts">
  import Vue from "vue";
  import CodeMirrorEditor from "../../helpers/codeMirrorEditor";
  import CodeMirrorAble from "../../helpers/codeMirrorable";
  // tslint:disable-next-line:no-submodule-imports
  import "codemirror/addon/display/placeholder.js";

  export default Vue.extend({
    props: {
      value: {
        type: String
      },
      id: {
        type: String
      },
      config: {
        type: Object as () => {mode: any, cursorHeight: number}
      },
      codeMirrorAble: {
        type: Object as () => typeof CodeMirrorAble,
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        defaultConfig: {
          mode: null,
          cursorHeight: 1,
        },
        editor: null,
        _value: null
      }
    },
    computed: {
      codeMirrorConfig() {
        return Object.assign(this.defaultConfig, this.config)
      }
    },
    mounted() {
      this.$data._value = this.value;
      this.$nextTick(() => {
        this.editor = new CodeMirrorEditor(`#${this.id}`, this.codeMirrorConfig, this.codeMirrorAble);
        this.editor.codeMirror.on('change', (cm, changeObj) => {
          this.$data._value = cm.getValue();
        });
        $(this.editor.wrapperElement).on('chip:cleared', (e: Event) => {
          this.$emit('chip-cleared', e)
        });

        // prevents chrome specific bug where editor becomes uneditable when clicking formula pill in form builder paragraph element
        setTimeout(() => {
          this.editor.codeMirror.focus()
        }, 100);

      });
    },
    methods: {
      emitInput() {
        this.$emit('input', this.$data._value);
      }
    },
    beforeDestroy() {
      this.editor?.removeEvents();
    },
    watch: {
      '$data._value': function(newVal: any) {
        this.emitInput();
      }
    }
  });
</script>